// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-fields {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background: #fff;
}

.map-fields-header {
  text-align: center;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.map-fields-header h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.map-fields-header p {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.mapping-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.section-header {
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.field-headers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.field-headers h3 {
  font-size: 1.2rem;
  color: #495057;
  margin: 0;
}

.field-mappings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.field-mapping-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.field-select-container {
  position: relative;
}

.field-select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  cursor: pointer;
}

.field-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.mapping-arrow {
  font-size: 1.2rem;
  color: #6c757d;
  font-weight: bold;
}

.delete-mapping-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.delete-mapping-btn:hover {
  background: #c82333;
}

.no-mappings {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.add-mapping-section {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

.add-mapping-btn {
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-mapping-btn:hover:not(:disabled) {
  background: #218838;
}

.add-mapping-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.add-mapping-disabled-text {
  margin-top: 0.5rem;
  color: #6c757d;
  font-size: 0.9rem;
}

.mapping-summary {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: #e9ecef;
  border-radius: 8px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.summary-label {
  font-size: 0.9rem;
  color: #6c757d;
}

.summary-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid #e9ecef;
}

.back-button {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.back-button:hover {
  background: #5a6268;
}

.continue-button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.continue-button:hover:not(:disabled) {
  background: #0056b3;
}

.continue-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.error-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
}

.error-content {
  text-align: center;
  max-width: 500px;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-content h2 {
  color: #dc3545;
  margin-bottom: 1rem;
}

.error-content p {
  color: #6c757d;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.retry-button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.retry-button:hover {
  background: #0056b3;
}

/* Responsive design */
@media (max-width: 768px) {
  .field-headers {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .field-mapping-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .mapping-arrow {
    transform: rotate(90deg);
    justify-self: center;
  }

  .mapping-summary {
    flex-direction: column;
    gap: 1rem;
  }

  .actions-section {
    flex-direction: column;
    gap: 1rem;
  }

  .back-button,
  .continue-button {
    width: 100%;
  }
}
.mapping-loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  height: 100vh;
}
.summary-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
}
.summary-section{
  width: -webkit-fill-available;
}`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/MapFields/MapFields.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".map-fields {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background: #fff;\n}\n\n.map-fields-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.map-fields-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.map-fields-header p {\n  font-size: 1.1rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.mapping-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.section-header {\n  margin-bottom: 2rem;\n}\n\n.section-header h2 {\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.field-headers {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.field-headers h3 {\n  font-size: 1.2rem;\n  color: #495057;\n  margin: 0;\n}\n\n.field-mappings {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.field-mapping-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  align-items: center;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.field-select-container {\n  position: relative;\n}\n\n.field-select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: white;\n  cursor: pointer;\n}\n\n.field-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.mapping-arrow {\n  font-size: 1.2rem;\n  color: #6c757d;\n  font-weight: bold;\n}\n\n.delete-mapping-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.delete-mapping-btn:hover {\n  background: #c82333;\n}\n\n.no-mappings {\n  text-align: center;\n  padding: 3rem;\n  color: #6c757d;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px dashed #dee2e6;\n}\n\n.add-mapping-section {\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.add-mapping-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-mapping-btn:hover:not(:disabled) {\n  background: #218838;\n}\n\n.add-mapping-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.add-mapping-disabled-text {\n  margin-top: 0.5rem;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.mapping-summary {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background: #e9ecef;\n  border-radius: 8px;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.summary-label {\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n.summary-value {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.back-button {\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.back-button:hover {\n  background: #5a6268;\n}\n\n.continue-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.continue-button:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.continue-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.error-screen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  padding: 2rem;\n}\n\n.error-content {\n  text-align: center;\n  max-width: 500px;\n}\n\n.error-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.error-content h2 {\n  color: #dc3545;\n  margin-bottom: 1rem;\n}\n\n.error-content p {\n  color: #6c757d;\n  margin-bottom: 2rem;\n  line-height: 1.5;\n}\n\n.retry-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.retry-button:hover {\n  background: #0056b3;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .field-headers {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .field-mapping-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .mapping-arrow {\n    transform: rotate(90deg);\n    justify-self: center;\n  }\n\n  .mapping-summary {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .actions-section {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n.mapping-loading-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  height: 100vh;\n}\n.summary-grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem;\n}\n.summary-section{\n  width: -webkit-fill-available;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
